var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"centered"},[_vm._v("Signing out...")])
}
var staticRenderFns = []

export { render, staticRenderFns }